var _rect, _path, _rect2, _rect3, _path2, _rect4, _path3, _rect5, _rect6, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInterview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 49,
    viewBox: "0 0 87 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.5273,
    y: 3.90527,
    width: 76.2162,
    height: 3.17568,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.49273 7.212C5.83673 7.212 6.71273 6.24 6.71273 4.764C6.71273 3.264 5.83673 2.316 4.49273 2.316C3.12473 2.316 2.26073 3.264 2.26073 4.764C2.26073 6.24 3.12473 7.212 4.49273 7.212ZM4.49273 9.084C2.10473 9.084 0.160728 7.296 0.160728 4.764C0.160728 2.232 2.10473 0.456 4.49273 0.456C6.89273 0.456 8.80073 2.232 8.80073 4.764C8.80073 6.24 8.15273 7.452 7.14473 8.22L8.99273 10.44H6.50873L5.42873 8.988C5.12873 9.048 4.81673 9.084 4.49273 9.084Z",
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.5273,
    y: 13.4324,
    width: 76.2162,
    height: 3.17568,
    fill: "#0B8FFC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10.5273,
    y: 19.1487,
    width: 76.2162,
    height: 3.17568,
    fill: "#0B8FFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.56142 22L6.05742 20.512H2.91342L2.40942 22H0.261415L3.30942 13.576H5.68542L8.73342 22H6.56142ZM5.52942 18.928L4.48542 15.844L3.45342 18.928H5.52942Z",
    fill: "#0B8FFC"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 10.5273,
    y: 30.5811,
    width: 76.2162,
    height: 3.17568,
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.49273 33.8878C5.83673 33.8878 6.71273 32.9158 6.71273 31.4398C6.71273 29.9398 5.83673 28.9918 4.49273 28.9918C3.12473 28.9918 2.26073 29.9398 2.26073 31.4398C2.26073 32.9158 3.12473 33.8878 4.49273 33.8878ZM4.49273 35.7598C2.10473 35.7598 0.160728 33.9718 0.160728 31.4398C0.160728 28.9078 2.10473 27.1318 4.49273 27.1318C6.89273 27.1318 8.80073 28.9078 8.80073 31.4398C8.80073 32.9158 8.15273 34.1278 7.14473 34.8958L8.99273 37.1158H6.50873L5.42873 35.6638C5.12873 35.7238 4.81673 35.7598 4.49273 35.7598Z",
    fill: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 10.5273,
    y: 40.1082,
    width: 76.2162,
    height: 3.17568,
    fill: "#0B8FFC"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 10.5273,
    y: 45.8242,
    width: 76.2162,
    height: 3.17568,
    fill: "#0B8FFC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.56142 49L6.05742 47.512H2.91342L2.40942 49H0.261415L3.30942 40.576H5.68542L8.73342 49H6.56142ZM5.52942 45.928L4.48542 42.844L3.45342 45.928H5.52942Z",
    fill: "#0B8FFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterview);
export default __webpack_public_path__ + "static/media/Interview.0830197022128c901e0f8569099b631e.svg";
export { ForwardRef as ReactComponent };